<template>
  <div>
    <div
      class="slide-panel--overlay"
      :class="{'slide-panel--overlay-active': isActive}"
      @click="hide"
    />
    <div
      class="d-md-flex slide-panel"
      :class="{'slide-panel--active': isActive}"
      :style="(isActive ? '' : `right: calc( -${width} - 30px);`)+ `width: ${width};`"
    >
      <div class="slide-panel__header" :class="followingPanel ? 'following-panel-header pb-3 pb-md-2' : 'mb-2'">
        <h4 v-if="header">
          {{ header }}
        </h4>
        <slot
          v-else
          name="header"
        />
        <span
          @click="hide"
          data-test-side-panel-close
          class="slide-panel__close"
        >
          <!-- TODO: lets do it like this until icons in storybook are fixed -->
          <svg width="16" height="16" viewBox="0 0 16 16" fill="" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00008 6.58586L13.293 1.29297L14.7072 2.70718L9.41429 8.00008L14.7072 13.293L13.293 14.7072L8.00008 9.41429L2.70718 14.7072L1.29297 13.293L6.58586 8.00008L1.29297 2.70718L2.70718 1.29297L8.00008 6.58586Z" fill=""/>
          </svg>
        </span>
      </div>
      <h6
        v-if="subheader"
        class="mb-2"
      >
        {{ subheader }}
      </h6>
      <slot
        v-else
        name="subheader"
      />
      <div class="hr mb-4" />
      <div class="slide-panel__body">
        <slot />
      </div>

      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      required: false,
      default: '500px',
    },
    header: {
      type: String,
      required: false,
    },
    subheader: {
      type: String,
      required: false,
    },
    bodyFlex: {
      type: Boolean,
      required: false,
      default: false,
    },
    followingPanel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false,
    }
  },
  methods: {
    show () {
      if (this.isActive) {
        return
      }

      this.isActive = true

      this.toggleBodyOverflow()
      this.$emit('show')
    },
    hide () {
      if (!this.isActive) {
        return
      }

      this.isActive = false

      this.toggleBodyOverflow()
      this.$emit('hide')
    },
    toggle () {
      this.isActive = !this.isActive

      this.toggleBodyOverflow()
      this.$emit(this.isActive ? 'show' : 'hide')
    },

    toggleBodyOverflow() {
      if (this.isActive) {
        document.querySelector('body').classList.add('overflow-hidden');
      } else {
        document.querySelector('body').classList.remove('overflow-hidden');
      }
    }
  },
}
</script>
<style lang="scss">
.slide-panel--overlay{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: #000;
  z-index: 809;
  transition: all 0.2s ease;
  pointer-events: none;
  opacity: 0;

  &-active {
    opacity: 0.75;
    pointer-events: unset;
  }
}
.slide-panel {
  position: fixed;
  top: 0;
  height: 100vh;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  background: white;
  z-index: 1000;
  box-shadow: 0 7px 32px rgba(0, 0, 0, 0.15);
  transition: right 0.3s ease;

  &--active {
    display: flex;
    right: 0;
  }

  &__header {
    display: flex;
    justify-content: space-between;

    &.following-panel-header {
      border-bottom: 1px solid $gray-200;
    }

    h4 {
      font-size: 24px;
    }

    .i {
      cursor: pointer;
      &:hover {
        color: black;
      }
    }
  }

  &__close {
    cursor: pointer;
    
    &:hover {
      svg {
        fill: $primary;
      }
    }
  }

  h6 {
    font-size: 18px;
    color: #757575;
  }

  .hr {
    width: 100%;
    height: 1px;
    background-color: rgba(36, 36, 36, 0.2);
  }

  &__body {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
  }

  @include media-breakpoint-down(sm) {
    display: none;
    padding: 16px;

    &--active {
      display: flex;
      width: 100vw !important;
    }

    &__header {
      h4 {
        font-size: 16px;
        line-height: 1.5;
        margin: 0;
      }
    }
  }
}
</style>
